import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest } from '../../lib/common'
import {Constants, setData, setLoading} from './actions'

function* getData(formData) {
  try {
    const request = axiosApi().post(
      Constants.GET_DATA_API,
      formData.payload
    )
    yield put(setLoading(true))
    
    const response = yield call(handleRequest, request)
    if (!response.data) {
      return
    }
    const data = JSON.parse(response.data)
    if (data) {
      yield put(setData(data))
    }
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoading(false))
  }
}

function* statsWatcher() {
  yield [
    takeLatest(Constants.GET_DATA, getData)
  ]
}

export default statsWatcher


// WEBPACK FOOTER //
// ./src/components/Stats/sagas.js